(() => {
  'use strict';
  if (window.__abmiumAthensCompare) return;
  window.__abmiumAthensCompare = true;

  const states = new Map();
  const VERSION = '2026-04';
  const COMPARE_QUERY = `query AbmiumCompareProducts($ids:[ID!]!,$country:CountryCode) @inContext(country:$country){
    nodes(ids:$ids){
      ... on Product{
        id
        metafields(identifiers:[
          {namespace:"specs",key:"target"},{namespace:"specs",key:"host"},{namespace:"specs",key:"clonality"},
          {namespace:"specs",key:"reactivity"},{namespace:"specs",key:"tested_applications"},{namespace:"specs",key:"isotype"},
          {namespace:"specs",key:"conjugation"},{namespace:"specs",key:"purification"},{namespace:"specs",key:"concentration"},
          {namespace:"specs",key:"cross_reactivity"},{namespace:"specs",key:"dilution_range"},{namespace:"specs",key:"assay_type"},
          {namespace:"specs",key:"detection_method"},{namespace:"specs",key:"sensitivity"},{namespace:"specs",key:"test_range"},
          {namespace:"specs",key:"sample_type"},{namespace:"specs",key:"expression"},{namespace:"specs",key:"expression_system"},
          {namespace:"specs",key:"tag"},{namespace:"specs",key:"purity"},{namespace:"specs",key:"molecular_weight"},
          {namespace:"specs",key:"activity"},{namespace:"specs",key:"specific_activity"},{namespace:"specs",key:"form"},
          {namespace:"specs",key:"origin"},{namespace:"specs",key:"optimal_temp"},{namespace:"specs",key:"extension_rate"},
          {namespace:"specs",key:"cell_type"},{namespace:"specs",key:"osmolality"},{namespace:"specs",key:"molecular_formula"},
          {namespace:"specs",key:"grade"},{namespace:"specs",key:"material"},{namespace:"specs",key:"capacity"},
          {namespace:"specs",key:"quantity_per_pack"},{namespace:"specs",key:"yield"},{namespace:"specs",key:"research_area"},
          {namespace:"specs",key:"research_areas"},{namespace:"ids",key:"gene_symbol"},{namespace:"ids",key:"uniprot_primary_ac"},
          {namespace:"ids",key:"cas_number"},{namespace:"ids",key:"ec_number"},{namespace:"logistics",key:"availability"},
          {namespace:"logistics",key:"dry_ice"}
        ]){namespace key value}
      }
    }
  }`;
  const COMPARE_HANDLE_QUERY = `query AbmiumCompareProductByHandle($handle:String!,$country:CountryCode) @inContext(country:$country){
    product(handle:$handle){
      id
      metafields(identifiers:[
        {namespace:"specs",key:"target"},{namespace:"specs",key:"host"},{namespace:"specs",key:"clonality"},
        {namespace:"specs",key:"reactivity"},{namespace:"specs",key:"tested_applications"},{namespace:"specs",key:"isotype"},
        {namespace:"specs",key:"conjugation"},{namespace:"specs",key:"purification"},{namespace:"specs",key:"concentration"},
        {namespace:"specs",key:"cross_reactivity"},{namespace:"specs",key:"dilution_range"},{namespace:"specs",key:"assay_type"},
        {namespace:"specs",key:"detection_method"},{namespace:"specs",key:"sensitivity"},{namespace:"specs",key:"test_range"},
        {namespace:"specs",key:"sample_type"},{namespace:"specs",key:"expression"},{namespace:"specs",key:"expression_system"},
        {namespace:"specs",key:"tag"},{namespace:"specs",key:"purity"},{namespace:"specs",key:"molecular_weight"},
        {namespace:"specs",key:"activity"},{namespace:"specs",key:"specific_activity"},{namespace:"specs",key:"form"},
        {namespace:"specs",key:"origin"},{namespace:"specs",key:"optimal_temp"},{namespace:"specs",key:"extension_rate"},
        {namespace:"specs",key:"cell_type"},{namespace:"specs",key:"osmolality"},{namespace:"specs",key:"molecular_formula"},
        {namespace:"specs",key:"grade"},{namespace:"specs",key:"material"},{namespace:"specs",key:"capacity"},
        {namespace:"specs",key:"quantity_per_pack"},{namespace:"specs",key:"yield"},{namespace:"specs",key:"research_area"},
        {namespace:"specs",key:"research_areas"},{namespace:"ids",key:"gene_symbol"},{namespace:"ids",key:"uniprot_primary_ac"},
        {namespace:"ids",key:"cas_number"},{namespace:"ids",key:"ec_number"},{namespace:"logistics",key:"availability"},
        {namespace:"logistics",key:"dry_ice"}
      ]){namespace key value}
    }
  }`;
  const FIELDS = {
    antibody:['__price','__sku','specs.target','specs.host','specs.clonality','specs.reactivity','specs.tested_applications','specs.isotype','specs.conjugation','specs.purification','specs.concentration','specs.cross_reactivity','specs.dilution_range','ids.gene_symbol','logistics.availability'],
    elisa_kit:['__price','__sku','specs.target','specs.reactivity','specs.assay_type','specs.detection_method','specs.sensitivity','specs.test_range','specs.sample_type','ids.gene_symbol','logistics.availability'],
    nucleic_kit:['__price','__sku','specs.assay_type','specs.reactivity','specs.sensitivity','specs.yield','specs.test_range','logistics.availability'],
    protein:['__price','__sku','specs.target','specs.expression','specs.tag','specs.purity','specs.molecular_weight','specs.activity','specs.specific_activity','specs.form','ids.uniprot_primary_ac','logistics.availability'],
    enzyme:['__price','__sku','specs.origin','specs.purity','specs.specific_activity','specs.optimal_temp','specs.extension_rate','specs.tested_applications','logistics.availability'],
    cell_culture:['__price','__sku','specs.form','specs.concentration','specs.osmolality','specs.cell_type','specs.reactivity','logistics.availability'],
    molecular_bio:['__price','__sku','specs.target','specs.assay_type','specs.reactivity','specs.cell_type','specs.concentration','logistics.availability'],
    detection:['__price','__sku','specs.detection_method','specs.conjugation','specs.sensitivity','specs.tested_applications','specs.reactivity','logistics.availability'],
    chemical:['__price','__sku','ids.cas_number','specs.molecular_formula','specs.molecular_weight','specs.purity','specs.grade','logistics.availability'],
    consumable:['__price','__sku','specs.material','specs.capacity','specs.quantity_per_pack','specs.purity','logistics.availability'],
    default:['__price','__type','__sku','specs.target','specs.reactivity','specs.tested_applications','specs.host','logistics.availability']
  };

  const clean = v => String(v ?? '').trim();
  const norm = v => clean(v).toLowerCase().replace(/[_-]+/g,' ').replace(/\s+/g,' ');
  function kind(type){
    const pt=norm(type);
    if(/antibod|isotype control|loading control|control lysate/.test(pt))return'antibody';
    if(/elisa kit|immunoassay kit|multiplex assay|biomarker panel/.test(pt))return'elisa_kit';
    if(/pcr reagent|qpcr|dna extraction kit|rna extraction kit|plasmid purification|reverse transcription kit/.test(pt))return'nucleic_kit';
    if(/recombinant protein|growth factor|cytokine/.test(pt))return'protein';
    if(/molecular biology enzyme|restriction enzyme|dna polymerase|rna polymerase|ligase|reverse transcriptase/.test(pt))return'enzyme';
    if(/cell culture medium|basal medium|serum alternative|cell culture supplement/.test(pt)||pt==='serum')return'cell_culture';
    if(/transfection|crispr|gene editing|sirna|shrna|cloning reagent|competent cells/.test(pt))return'molecular_bio';
    if(/western blot reagent|detection substrate|chemiluminescent|fluorescent dye/.test(pt))return'detection';
    if(/solvent|buffer component|inorganic reagent|lc ms grade|analytical reference|titration standard/.test(pt))return'chemical';
    if(/pipette tip|microcentrifuge tube|centrifuge tube|pcr plate|cell culture flask|syringe filter|cryovial/.test(pt))return'consumable';
    return'default';
  }
  function state(id){
    let s=states.get(id);
    if(!s){s={id,selected:new Map(),activeFields:[],showDiff:false};states.set(id,s);}
    s.ui=document.querySelector('[data-abm-athens-compare-ui="'+id+'"]');
    s.overlay=document.querySelector('[data-abm-compare-overlay="'+id+'"]');
    s.root=document.querySelector('[data-abm-catalogue][data-abm-compare-root="'+id+'"]');
    s.max=Number(s.ui?.dataset.maxProducts||5);
    return s;
  }
  function fieldLabel(f){
    if(f==='__price')return'Price';if(f==='__type')return'Product Type';if(f==='__vendor')return'Brand / Vendor';if(f==='__sku')return'Cat. Number';
    return f.split('.').pop().replace(/_/g,' ').replace(/\b\w/g,c=>c.toUpperCase());
  }
  function readVisible(card,key){
    const needle=norm(key);
    const map={tested_applications:['applications','tested applications'],reactivity:['reactivity','species'],sample_type:['sample type','sample types'],molecular_weight:['mol. weight','molecular weight'],gene_symbol:['gene','gene symbol','gene / uniprot'],uniprot_primary_ac:['uniprot','gene / uniprot'],quantity_per_pack:['qty / pack']};
    const wanted=[needle,...(map[key]||[])];
    for(const dt of card.querySelectorAll('.abm-card__facts dt')){
      if(wanted.includes(norm(dt.textContent))) return clean(dt.nextElementSibling?.textContent);
    }
    return '';
  }
  function deriveHandle(card){
    const href=card.dataset.abmUrl || card.querySelector('h2 a[href*="/products/"],.abm-card__media[href*="/products/"]')?.href || '';
    try{
      const match=new URL(href,location.origin).pathname.match(/\/products\/([^/?#]+)/i);
      return match?decodeURIComponent(match[1]):'';
    }catch(_){return '';}
  }
  function ensureCompareCard(card){
    if(!card||!card.matches?.('.abm-card')) return;
    const handle=card.dataset.abmCompareKey || deriveHandle(card);
    if(!handle) return;
    const title=card.dataset.abmTitle || card.querySelector('h2,.abm-card-title')?.textContent?.trim() || handle;
    const href=card.dataset.abmUrl || card.querySelector('h2 a[href*="/products/"],.abm-card__media[href*="/products/"]')?.href || '';
    const vendor=card.dataset.abmVendor || card.querySelector('.abm-card__topline a')?.textContent?.trim() || '';
    const codeSpans=[...card.querySelectorAll('.abm-card__codes span')].map(node=>node.textContent.trim()).filter(Boolean);
    const sku=card.dataset.abmSku || (codeSpans.find(value=>/^SKU\s+/i.test(value))||'').replace(/^SKU\s+/i,'');
    const type=card.dataset.abmType || codeSpans.find(value=>!/^SKU\s+/i.test(value)) || '';
    const price=card.dataset.abmPrice || card.querySelector('.abm-card__price strong')?.textContent?.trim() || '';
    const image=card.dataset.abmImage || card.querySelector('img')?.src || '';
    const available=card.dataset.abmAvailable || String(card.querySelector('.abm-stock')?.classList.contains('abm-stock--yes') || /available/i.test(card.querySelector('.abm-stock')?.textContent||''));
    card.dataset.abmCompareKey=handle;
    card.dataset.abmTitle=title;
    card.dataset.abmVendor=vendor;
    card.dataset.abmType=type;
    card.dataset.abmSku=sku;
    card.dataset.abmUrl=href;
    card.dataset.abmPrice=price;
    card.dataset.abmImage=image;
    card.dataset.abmAvailable=available;
    if(!card.querySelector('[data-abm-athens-compare-checkbox]')){
      const label=document.createElement('label');
      label.className='abm-compare-label';
      const checkbox=document.createElement('input');
      checkbox.type='checkbox';
      checkbox.value=handle;
      checkbox.dataset.abmAthensCompareCheckbox='';
      checkbox.setAttribute('aria-label','Compare '+title);
      label.append(checkbox,document.createTextNode(' Compare'));
      const codes=card.querySelector('.abm-card__codes');
      if(codes) codes.insertAdjacentElement('afterend',label);
      else card.querySelector('.abm-card__content')?.prepend(label);
    }
  }
  function productFromCard(card){
    ensureCompareCard(card);
    const key=card.dataset.abmCompareKey||card.dataset.handle||deriveHandle(card)||'';
    const mf={};
    for(const attr of card.attributes){
      if(attr.name.startsWith('data-mf-')){
        const raw=attr.name.slice(8);
        const dash=raw.indexOf('-');
        if(dash>0) mf[raw.slice(0,dash)+'.'+raw.slice(dash+1)]=attr.value;
      }
    }
    return {
      id:key,key,gid:card.dataset.abmProductGid||'',title:card.dataset.abmTitle||card.querySelector('h2,.abm-card-title')?.textContent?.trim()||key,
      price:card.dataset.abmPrice||card.querySelector('.abm-card__price strong,.abm-list-price')?.textContent?.trim()||'',
      priceRaw:card.dataset.abmPriceRaw||'',type:card.dataset.abmType||'',vendor:card.dataset.abmVendor||'',
      sku:card.dataset.abmSku||'',url:card.dataset.abmUrl||card.querySelector('h2 a,.abm-card-title a')?.href||'',
      img:card.dataset.abmImage||card.querySelector('img')?.src||'',available:card.dataset.abmAvailable!=='false',
      ptype:kind(card.dataset.abmType||''),mf,card
    };
  }
  function val(p,f){
    if(f==='__price')return p.price||'';if(f==='__type')return p.type||'';if(f==='__vendor')return p.vendor||'';if(f==='__sku')return p.sku||'';
    if(p.mf[f])return p.mf[f];
    const parts=f.split('.');return parts.length===2?readVisible(p.card,parts[1]):'';
  }
  function compareEndpoints(){
    const urls=[location.origin+'/api/'+VERSION+'/graphql.json'];
    if(window.Shopify?.shop)urls.push('https://'+window.Shopify.shop+'/api/'+VERSION+'/graphql.json');
    return [...new Set(urls)];
  }
  function applyCompareNode(product,node){
    if(!node)return;
    if(node.id&&!product.gid)product.gid=node.id;
    for(const mf of node.metafields||[]){
      if(!mf)continue;
      product.mf[mf.namespace+'.'+mf.key]=mf.value||'';
    }
    if(!product.mf['specs.expression']&&product.mf['specs.expression_system'])product.mf['specs.expression']=product.mf['specs.expression_system'];
    if(!product.mf['specs.research_area']&&product.mf['specs.research_areas'])product.mf['specs.research_area']=product.mf['specs.research_areas'];
    product.compareEnriched=true;
  }
  async function storefrontFetch(query,variables,select){
    let last=null;
    for(const endpoint of compareEndpoints()){
      try{
        const response=await fetch(endpoint,{
          method:'POST',
          headers:{'Content-Type':'application/json',Accept:'application/json'},
          credentials:endpoint.startsWith(location.origin)?'same-origin':'omit',
          body:JSON.stringify({query,variables})
        });
        if(!response.ok)throw new Error('Storefront '+response.status);
        const json=await response.json();
        if(json.errors?.length)throw new Error(json.errors[0].message);
        return select(json.data);
      }catch(error){last=error;}
    }
    throw last||new Error('Storefront compare request failed');
  }
  async function enrichSelected(s){
    const products=[...s.selected.values()].filter(p=>!p.compareEnriched);
    if(!products.length)return;
    const withGid=products.filter(p=>p.gid);
    if(withGid.length){
      try{
        const ids=[...new Set(withGid.map(p=>p.gid))];
        const nodes=await storefrontFetch(COMPARE_QUERY,{ids,country:window.Shopify?.country||null},data=>data?.nodes||[]);
        const byId=new Map(nodes.filter(Boolean).map(node=>[node.id,node]));
        withGid.forEach(p=>applyCompareNode(p,byId.get(p.gid)));
      }catch(error){console.warn('[ABMIUM] Compare ID metafields unavailable.',error);}
    }
    const byHandle=products.filter(p=>!p.compareEnriched&&p.key);
    await Promise.all(byHandle.map(async p=>{
      try{
        const node=await storefrontFetch(COMPARE_HANDLE_QUERY,{handle:p.key,country:window.Shopify?.country||null},data=>data?.product||null);
        applyCompareNode(p,node);
      }catch(error){console.warn('[ABMIUM] Compare handle metafields unavailable.',p.key,error);}
    }));
  }
  function fieldsFor(products){
    const types=[...new Set(products.map(p=>p.ptype||'default'))];
    if(types.length===1)return(FIELDS[types[0]]||FIELDS.default).slice();
    const merged=['__price','__type','__sku'],seen=new Set(merged);
    for(const t of types)for(const f of(FIELDS[t]||FIELDS.default))if(!seen.has(f)){seen.add(f);merged.push(f);}
    return merged;
  }
  function syncCards(s){
    document.querySelectorAll('[data-abm-catalogue][data-abm-compare-root="'+s.id+'"] .abm-card').forEach(card=>{
      ensureCompareCard(card);
      const key=card.dataset.abmCompareKey;
      if(!key)return;
      const active=s.selected.has(key);
      card.classList.toggle('selected',active);
      card.querySelectorAll('[data-abm-athens-compare-checkbox]').forEach(cb=>{cb.checked=active;});
    });
  }
  function bodyPad(){
    const any=[...states.values()].some(s=>s.selected.size>0);
    document.body.style.paddingBottom=any?(window.innerWidth>=769?'88px':'72px'):'';
  }
  function renderBar(s){
    if(!s.ui)return;
    const items=[...s.selected.values()],count=items.length;
    s.ui.style.display=count?'flex':'none';
    const badge=s.ui.querySelector('.cbar-count');if(badge)badge.textContent=count+' / '+s.max;
    const btn=s.ui.querySelector('.cbar-btn-go');if(btn)btn.disabled=count<2;
    const slots=s.ui.querySelector('.cbar-slots');
    if(slots){slots.replaceChildren();for(const p of items){const chip=document.createElement('div');chip.className='cbar-slot';const title=document.createElement('span');title.className='cbar-slot-title';title.title=p.title;title.textContent=p.title.length>22?p.title.slice(0,22)+'…':p.title;const x=document.createElement('button');x.type='button';x.className='cbar-slot-x';x.setAttribute('aria-label','Remove');x.innerHTML='&times;';x.addEventListener('click',()=>remove(s,p.key,true));chip.append(title,x);slots.append(chip);}}
    syncCards(s);bodyPad();
  }
  function toast(msg){
    const t=document.createElement('div');t.textContent=msg;Object.assign(t.style,{position:'fixed',bottom:'80px',left:'50%',transform:'translateX(-50%)',background:'rgba(11,25,41,.9)',color:'#fff',padding:'10px 20px',borderRadius:'8px',fontSize:'13px',zIndex:'100001',boxShadow:'0 4px 20px rgba(0,0,0,.3)',pointerEvents:'none',whiteSpace:'nowrap'});document.body.appendChild(t);setTimeout(()=>t.remove(),3000);
  }
  function toggle(cb){
    const card=cb.closest('.abm-card'),root=card?.closest('[data-abm-catalogue][data-abm-compare-root]');
    if(!card||!root)return;const s=state(root.dataset.abmCompareRoot),p=productFromCard(card);
    if(cb.checked){
      if(!s.selected.has(p.key)&&s.selected.size>=s.max){cb.checked=false;toast('You can compare up to '+s.max+' products at once.');return;}
      s.selected.set(p.key,p);
    }else s.selected.delete(p.key);
    renderBar(s);
  }
  function remove(s,key,rebuild){
    s.selected.delete(key);renderBar(s);
    if(rebuild&&s.overlay?.classList.contains('open'))build(s);
  }
  function clear(s){s.selected.clear();renderBar(s);}
  function build(s){
    if(!s.overlay)return;
    const prods=[...s.selected.values()];
    if(!s.activeFields.length)s.activeFields=fieldsFor(prods);
    const table=s.overlay.querySelector('.ov-table'),head=table?.querySelector('thead tr'),body=table?.querySelector('tbody');
    if(!table||!head||!body)return;
    head.innerHTML='<th class="col-label"><div class="col-label-inner">Attribute</div></th>';
    for(const p of prods){
      const th=document.createElement('th');th.className='col-prod';
      const wrap=document.createElement('div');wrap.className='col-prod-wrap';
      const info=document.createElement('div');
      const a=document.createElement('a');a.className='col-prod-name';a.href=p.url||'#';a.target='_blank';a.textContent=p.title.length>45?p.title.slice(0,45)+'…':p.title;
      const sku=document.createElement('div');sku.className='col-prod-sku';sku.textContent=p.sku||'';
      const x=document.createElement('button');x.type='button';x.className='col-prod-remove';x.innerHTML='&times;';x.setAttribute('aria-label','Remove '+p.title);x.addEventListener('click',()=>remove(s,p.key,true));
      info.append(a,sku);wrap.append(info,x);th.append(wrap);head.append(th);
    }
    body.replaceChildren();
    for(const f of s.activeFields){
      const row=document.createElement('tr'),label=document.createElement('td');label.className='col-label';label.innerHTML='<div class="col-label-inner">'+fieldLabel(f)+'</div>';row.append(label);
      const values=prods.map(p=>val(p,f));const same=values.length>1&&values.every(v=>v===values[0]);
      prods.forEach((p,i)=>{const td=document.createElement('td');td.className='col-val';const value=values[i];
        if(f==='__price'&&value){const strong=document.createElement('strong');strong.style.cssText='font-size:15px;font-weight:800';strong.textContent=value;td.append(strong);}
        else if(f==='__vendor'&&value){const span=document.createElement('span');span.style.cssText='color:#0A66C2;font-weight:600';span.textContent=value;td.append(span);}
        else if(f==='logistics.availability'&&value){const span=document.createElement('span');const ok=/stock|available|true/i.test(value);span.className='ov-stock-badge'+(ok?'':' out');span.textContent=ok?'In Stock':value;td.append(span);}
        else if(f==='__sku'&&value){const span=document.createElement('span');span.style.cssText='font-family:monospace;font-size:12px;font-weight:600;color:#0A66C2';span.textContent=value;td.append(span);}
        else if(value)td.textContent=value;else{const span=document.createElement('span');span.className='ov-empty';span.textContent='-';td.append(span);}
        if(s.showDiff&&values.length>1)td.classList.add(same?'ov-same':'ov-diff');row.append(td);
      });body.append(row);
    }
  }
  async function open(s){const prods=[...s.selected.values()];if(prods.length<2)return;await enrichSelected(s);s.activeFields=fieldsFor(prods);build(s);s.overlay?.classList.add('open');document.body.style.overflow='hidden';}
  function close(s){s.overlay?.classList.remove('open');document.body.style.overflow='';}
  function scan(scope=document){
    const roots=[];
    if(scope?.matches?.('[data-abm-catalogue][data-abm-compare-root]')) roots.push(scope);
    scope?.querySelectorAll?.('[data-abm-catalogue][data-abm-compare-root]').forEach(root=>roots.push(root));
    roots.forEach(root=>root.querySelectorAll('.abm-card').forEach(ensureCompareCard));
    if(scope?.matches?.('[data-abm-athens-compare-ui]')){const s=state(scope.dataset.abmAthensCompareUi);renderBar(s);}
    scope?.querySelectorAll?.('[data-abm-athens-compare-ui]').forEach(ui=>{const s=state(ui.dataset.abmAthensCompareUi);renderBar(s);});
    for(const s of states.values())syncCards(s);
  }
  document.addEventListener('change',e=>{const cb=e.target.closest?.('[data-abm-athens-compare-checkbox]');if(cb)toggle(cb);});
  document.addEventListener('click',e=>{
    const openBtn=e.target.closest?.('[data-abm-compare-open]');if(openBtn){open(state(openBtn.dataset.abmCompareOpen));return;}
    const clearBtn=e.target.closest?.('[data-abm-compare-clear]');if(clearBtn){clear(state(clearBtn.dataset.abmCompareClear));return;}
    const closeBtn=e.target.closest?.('[data-abm-compare-close]');if(closeBtn){close(state(closeBtn.dataset.abmCompareClose));return;}
    const addBtn=e.target.closest?.('[data-abm-compare-add-row]');if(addBtn){const s=state(addBtn.dataset.abmCompareAddRow),sel=s.overlay?.querySelector('.ov-field-sel');if(sel?.value&&!s.activeFields.includes(sel.value)){s.activeFields.push(sel.value);build(s);}if(sel)sel.value='';return;}
    const resetBtn=e.target.closest?.('[data-abm-compare-reset]');if(resetBtn){const s=state(resetBtn.dataset.abmCompareReset);s.activeFields=fieldsFor([...s.selected.values()]);build(s);return;}
  });
  document.addEventListener('change',e=>{const diff=e.target.closest?.('[data-abm-compare-diff]');if(diff){const s=state(diff.dataset.abmCompareDiff);s.showDiff=diff.checked;build(s);}});
  document.addEventListener('keydown',e=>{if(e.key==='Escape')for(const s of states.values())if(s.overlay?.classList.contains('open'))close(s);});
  document.addEventListener('abmium:catalogue-ready',e=>scan(e.target));
  document.addEventListener('abmium:target-catalogue-ready',e=>scan(e.detail?.root||document));
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>scan(),{once:true});else scan();
  const main=document.getElementById('MainContent');
  if(main)new MutationObserver(records=>{
    const hasCardChange=records.some(record=>[...record.addedNodes].some(node=>
      node.nodeType===1 && (node.matches?.('.abm-card,[data-abm-catalogue]') || node.querySelector?.('.abm-card,[data-abm-catalogue]'))
    ));
    if(hasCardChange)scan(main);
  }).observe(main,{childList:true,subtree:true});
})();